import { __assign } from "tslib";
import { combine, computeStackTrace, formatUnknownError, getTimestamp, startAutomaticErrorCollection, } from '@datadog/browser-core';
import { RumEventCategory } from '../../../types';
import { RumEventType } from '../../../typesV2';
import { LifeCycleEventType } from '../../lifeCycle';
export function startErrorCollection(lifeCycle, configuration) {
    return doStartErrorCollection(lifeCycle, configuration, startAutomaticErrorCollection(configuration));
}
export function doStartErrorCollection(lifeCycle, configuration, observable) {
    observable.subscribe(function (error) {
        configuration.isEnabled('v2_format')
            ? lifeCycle.notify(LifeCycleEventType.RAW_RUM_EVENT_V2_COLLECTED, processErrorV2(error))
            : lifeCycle.notify(LifeCycleEventType.RAW_RUM_EVENT_COLLECTED, processError(error));
    });
    return {
        addError: function (_a, savedGlobalContext) {
            var error = _a.error, startTime = _a.startTime, customerContext = _a.context, source = _a.source;
            var rawError = computeRawError(error, startTime, source);
            configuration.isEnabled('v2_format')
                ? lifeCycle.notify(LifeCycleEventType.RAW_RUM_EVENT_V2_COLLECTED, __assign({ customerContext: customerContext,
                    savedGlobalContext: savedGlobalContext }, processErrorV2(rawError)))
                : lifeCycle.notify(LifeCycleEventType.RAW_RUM_EVENT_COLLECTED, __assign({ customerContext: customerContext,
                    savedGlobalContext: savedGlobalContext }, processError(rawError)));
        },
    };
}
function computeRawError(error, startTime, source) {
    var stackTrace = error instanceof Error ? computeStackTrace(error) : undefined;
    return __assign({ startTime: startTime, source: source }, formatUnknownError(stackTrace, error, 'Provided'));
}
function processError(error) {
    var rawRumEvent = combine({
        date: getTimestamp(error.startTime),
        error: {
            kind: error.type,
            origin: error.source,
            stack: error.stack,
        },
        evt: {
            category: RumEventCategory.ERROR,
        },
        message: error.message,
    }, error.resource
        ? {
            http: {
                method: error.resource.method,
                status_code: error.resource.statusCode,
                url: error.resource.url,
            },
        }
        : undefined);
    return {
        rawRumEvent: rawRumEvent,
        startTime: error.startTime,
    };
}
function processErrorV2(error) {
    var rawRumEvent = {
        date: getTimestamp(error.startTime),
        error: {
            message: error.message,
            resource: error.resource,
            source: error.source,
            stack: error.stack,
            type: error.type,
        },
        type: RumEventType.ERROR,
    };
    return {
        rawRumEvent: rawRumEvent,
        startTime: error.startTime,
    };
}
//# sourceMappingURL=errorCollection.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@datadog/browser-rum/esm/domain/rumEventsCollection/error/errorCollection.js
// module id = 4ypX
// module chunks = 1